import { render } from "./BodyText.vue?vue&type=template&id=1f89c090"
import script from "./BodyText.vue?vue&type=script&lang=js"
export * from "./BodyText.vue?vue&type=script&lang=js"

import exportComponent from "/Users/unipar/Code/neo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__